import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../withTypes';
import { Status, STATUSES } from '@/types/store';
import { Language, Role } from '@/graphql/types';
import { fetchInitialData } from '@/api/users';
import { errorMessages } from '@/utils/errorMessages';
import { showRejectedToast } from '@/api/graphqlClient';

export interface UsersState {
  roles: Role[];
  languages: Language[];
  status: Status;
}

const initialState: UsersState = {
  roles: [],
  languages: [],
  status: STATUSES.IDLE,
};

/* THUNKS */
export const fetchBaseData = createAppAsyncThunk(
  'users/baseData',
  async () => {
    return await fetchInitialData();
  },
);

export const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBaseData.pending, (state) => {
      state.status = STATUSES.PENDING;
    });
    builder.addCase(fetchBaseData.fulfilled, (state, action) => {
      state.roles = action.payload.roles;
      state.languages = action.payload.languages;
      state.status = STATUSES.FULFILLED;
    });
    builder.addCase(fetchBaseData.rejected, (state, action) => {
      state.roles = initialState.roles;
      state.languages = initialState.languages;
      showRejectedToast(action, errorMessages.fetchingUserData);
    });
  },
});

export default userReducer.reducer;
